__turbopack_context__.v({
  "body": "vh0UWa_body",
  "buttons": "vh0UWa_buttons",
  "container": "vh0UWa_container",
  "header": "vh0UWa_header",
  "icon": "vh0UWa_icon",
  "inputs": "vh0UWa_inputs",
  "select": "vh0UWa_select",
});
